import WorkFlowView from '../view/WorkFlowView';
import NodeViewConstructorArgs from '../constructor/NodeViewConstructorArgs';
import View from '../view/View';
import Position from '../support/Position';
import * as d3 from 'd3';
import { Syntax, Token } from '@trlogic/ui-pack';
import NodeMouseEvent from '../support/NodeMouseEvent';

abstract class AbstractNodeView implements View<Syntax> {
  protected readonly workFlowView: WorkFlowView;
  protected readonly model: Syntax;
  protected el: string;
  protected shadow: boolean;

  protected constructor(args: NodeViewConstructorArgs) {
    this.workFlowView = args.workFlowView;
    this.model = args.model;
    this.el = args.el;
    this.shadow = args.shadow || false;
  }

  public isShadow(): boolean {
    return this.shadow;
  }

  public getWorkFlowView(): WorkFlowView {
    return this.workFlowView;
  }

  public getModel<T extends Token>(): Syntax<T> {
    return this.model as Syntax<T>;
  }

  public abstract initialize(): void;

  public getNode(): string {
    return this.el;
  }

  public terminate(): void {
    d3.select(this.el).remove();
  }

  public abstract socketHighlight(type?: string): void;

  public abstract socketUnHighlight(type?: string, event?: NodeMouseEvent): void;

  public opacity(opacity: number): void {
    d3.select(this.el).attr('opacity', opacity / 100);
  }

  public renderPosition(position: Position): void {
    d3.select(this.el).style('left', `${position.x}px`).style('top', `${position.y}px`);
  }

  public renderTreeNodePosition(position: Position): void {
    d3.select(this.el).attr('transform', function (d: any) {
      return 'translate(' + position.x + ',' + position.y + ')';
    });
  }

  protected abstract preSwap(target: View<Syntax>): boolean;

  public abstract setModel(model: Syntax): void;

  public swap(target: View<Syntax>): void {
    const canSwap = this.preSwap(target);
    if (!canSwap) return;

    const cModel: Syntax = this.getModel();
    const tModel: Syntax = target.getModel();
    const cParent = cModel.parent;
    const tParent = tModel.parent;

    if (cParent == undefined || tParent == undefined || cParent.children == undefined || tParent.children == undefined) {
      return;
    }

    const cIndex = cParent.children.indexOf(cModel);
    if (cIndex == -1) return;
    const cPopped = cParent.children.splice(cIndex, 1)[0];

    const tIndex = tParent.children.indexOf(tModel);
    if (tIndex == -1) {
      return;
    }
    const tPopped = tParent.children.splice(tIndex, 1)[0];

    if (cPopped == undefined || tPopped == undefined) {
      console.log(cPopped, tPopped);
      console.log('popped error');
      return;
    }

    tModel.parent = cParent;
    cModel.parent = tParent;
    tParent.children.splice(tIndex, 0, cModel);
    cParent.children.splice(cIndex, 0, tModel);
  }

  public pause() {}

  public resume() {}
}

export default AbstractNodeView;
